import { CheckCircle2 } from "lucide-react";
import type { ChatAnswerWidget } from "./hooks/useChatUiActions";

interface ChatAnswerStreamWidgetsProps {
  widgets: ChatAnswerWidget[];
}

export function ChatAnswerStreamWidgets({
  widgets,
}: ChatAnswerStreamWidgetsProps) {
  if (widgets.length === 0) return null;

  return (
    <>
      {widgets.map((widget) => (
        <div
          key={widget.id}
          className="flex justify-end text-right"
          title={widget.title}
        >
          <span className="inline-flex items-center gap-1.5 text-[11px] italic text-[var(--fintheon-text)]/45">
            <CheckCircle2
              size={12}
              className="text-[var(--fintheon-accent)]/65"
            />
            answers captured
          </span>
        </div>
      ))}
    </>
  );
}
